<template>
    <div
        class="zc-widget-config"
        :data-restaurant="restaurantId"
        data-open="2000" />
    <button
        v-show="false"
        ref="zenchefCloseButton"
        data-zc-action="close"
    >CLOSE ZENCHEF</button>
    <button
        v-show="false"
        ref="zenchefOpenButton"
        data-zc-action="open"
    >OPEN ZENCHEF</button>
</template>

<script setup lang="ts">
const props = defineProps({
    restaurantId: {
        type: String,
        required: true,
        default: ''
    }
});

const zenchefCloseButton = useTemplateRef('zenchefCloseButton');
const zenchefOpenButton = useTemplateRef('zenchefOpenButton');

const { remove } = useScript({
    id: 'zenchef-sdk',
    async: true,
    src: 'https://sdk.zenchef.com/v1/sdk.min.js',
    crossorigin: false,
});

onMounted(() => {
    // Ensure the Zenchef widget is closed when the component is mounted
    zenchefOpenButton.value?.click();
});

onBeforeUnmount(() => {
    zenchefCloseButton.value?.click();

    remove();

    document.querySelectorAll('iframe[class^=ZC_sdk]')?.forEach(script => {
        script.remove();
    });
});
</script>
